import { render, staticRenderFns } from "./Wages.vue?vue&type=template&id=3d9baa62&scoped=true&"
import script from "./Wages.vue?vue&type=script&lang=js&"
export * from "./Wages.vue?vue&type=script&lang=js&"
import style0 from "./Wages.vue?vue&type=style&index=0&id=3d9baa62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9baa62",
  null
  
)

export default component.exports